/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Modal from "components/modal";
import TextInput from "components/input";
import * as yup from "yup";
import { TypeNotification } from "utils/constants";
import { JA } from "utils/strings.ja";

let schemaForm = yup.object().shape({
  title: yup.string().required(JA.validation.titleRequired),
  redirectURL: yup
    .string()
    .required(JA.validation.redirectUrlRequired)
    .url(JA.validation.redirectUrlRequired),
});

export default function NotificationModal({
  isOpen = false,
  handleUpdateNotication = () => {},
  handleCloseModal = () => {},
  detailNotification = {},
}) {
  const [notificationItem, setNotificationItem] = useState({
    title: "",
    redirectURL: "",
    target: TypeNotification.NTT,
  });

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setNotificationItem({
      id: detailNotification.id,
      title: detailNotification.title,
      redirectURL: detailNotification.redirectURL,
      target: detailNotification.target,
    });
  }, [detailNotification]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setNotificationItem({
      ...notificationItem,
      [name]: value,
    });
  };

  const handleUpdate = async () => {
    setErrors([]);
    schemaForm
      .validate(notificationItem, { abortEarly: false })
      .then((vl) => {
        handleUpdateNotication(notificationItem);
      })
      .catch((err) => {
        console.log(err.errors);
        setErrors(err.errors);
      });
  };

  return (
    <Modal
      title={detailNotification.id ? JA.notification.update : JA.notification.create}
      isOpen={isOpen}
      primaryButton={JA.common.save}
      handleCloseModal={handleCloseModal}
      cancelText={JA.common.cancel}
      primaryAction={handleUpdate}
    >
      <div className="flex flex-col gap-6">
        <div>
          <TextInput
            label={JA.notification.titleField}
            name="title"
            value={notificationItem.title}
            onChange={handleInputChange}
            placeholder={JA.notification.titleField}
          />
        </div>
        <div>
          <TextInput
            label={JA.notification.redirectUrl}
            placeholder={JA.notification.redirectUrl}
            name="redirectURL"
            value={notificationItem.redirectURL}
            onChange={handleInputChange}
          />
        </div>
        <div>
          {/* pick analysis mode */}
          <div className="flex flex-col justify-between w-full mb-5">
            <label className="mb-2.5 block text-base font-medium text-black dark:text-white">
              {JA.notification.target}
            </label>
            <select
              name="target"
              className="py-2 pl-6 pr-10 bg-transparent border rounded-lg outline-hidden border-stroke focus:border-brand focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:focus:border-brand disabled:bg-slate-100 disabled:cursor-not-allowed"
              onChange={handleInputChange}
              value={notificationItem.target}
              disabled={!!detailNotification.id}
            >
              {Object.keys(TypeNotification).map((key, index) => (
                <option key={index} value={key}>
                  {key}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* show errors */}
        <div className="flex flex-col">
          {errors.length > 0 &&
            errors.map((item) => <span className="text-red-700">{item}</span>)}
        </div>
      </div>
    </Modal>
  );
}
